/**
 * @desc 保存
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.ChangeApprovalRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/srm/changeApproval/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
